import { RELATIONSHIP_SUBTITLES } from '@/components/CorporateUsers/Onboarding/constants';

/** The banner eyebrow: the carrier's organization_carrier_statuses `relationship`, as the onboarding cards name it. */
export const eyebrowFor = (relationship) => RELATIONSHIP_SUBTITLES[relationship] || 'Carrier';
